import { Component, Input, ViewChild } from '@angular/core';
import { ModalController, NavController, Platform, AlertController } from 'ionic-angular';
import { SearchDisplayCheck } from '../../provider/searchVisibility';
import * as Constants from '../../provider/Constants';
import { ParentCustomSuperTabs } from '../../customviews/customparenttabs/parentcustomsupertabs';
import { Subscription } from 'rxjs';
import { Network } from '@ionic-native/network';
import { ChildtabsPage } from '../childtabs/childtabs';
import { TabPage } from '../tabpage/tabpage';
/**ß
 * Generated class for the ParenttabsPage tabs.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'parent-tabs',
  templateUrl: 'parenttabs.html'
})
export class ParenttabsPage {
  @ViewChild('parentTab') psuperTabs: ParentCustomSuperTabs;

  searchEnable = false;
  searchenableSubscription: Subscription;

   tabsparent = [
    Constants.RECOMMENDED,
    Constants.LOCAL,
    Constants.ONLINE,
    Constants.VACATIONS,
    Constants.FEATURED,
    Constants.FAVORITES,
    Constants.AAA_DOLLARS
  ];


  _index: any = '0';
  @Input()
  set index(index: any) {
    index === 'vacations' ? this._index = '3' : this._index = '0';
  }


  constructor(
    public navCtrl: NavController,
    private searchVisibleData: SearchDisplayCheck,
    private platform: Platform,
    private network: Network,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController) { }


  ngOnInit(): void {
    this.searchenableSubscription = this.searchVisibleData.currentMessage.subscribe(message => this.searchEnable = message);

  }


  gotoSearch(event) {
    const isNetConnected = this.checkDeviceNetworkConnection();
    if(!isNetConnected) {
      this.showNetworkAlert();
      return;
    }
    this.searchEnable = true;
    this.removesearchResults();

  }

  receiveMessage($event) {
    this.searchEnable = $event;
  }

  onTabSelect(ev: any) {
    console.log('Tab selected parent', 'Index: ' + ev.index, 'Unique ID: ' + ev.id);
    this.removesearchResults();
    // this.searchVisibleData.popTab(true);
  }

  removesearchResults() {
    // this.searchVisibleData.changeVisibility(false);

    this.searchVisibleData.changeSearchResVisibility({ 'searchres': false });
  }
  ngOnDestroy() {
    console.log('parent tabs ondestroy');
    this.searchenableSubscription.unsubscribe();
  }

  checkDeviceNetworkConnection():boolean {
    if (this.platform.is('cordova')) {
      const isNetworkAvailable = (this.network.type === 'none') ? false : true;
      return isNetworkAvailable;
    }
  }

  showNetworkAlert() {
    let alert = this.alertCtrl.create({
      title: Constants.internetAlertTitle,
      subTitle: Constants.internetAlertMessage,
      buttons: [Constants.alertPositiveButtonTitle]
    });
    alert.present();
  }

}
